
import { storedRef } from './utils.js';

const activity = 3;

export const seenPlayerDialog = storedRef( activity, 'seen-player-dialog', false );

export const letterScenario = storedRef( activity, 'letter-scenario', null );

export const letterBackground = storedRef( activity, 'letter-background', null );

export const letterContent = storedRef( activity, 'letter-content', null );

export const hasDownloaded = storedRef( activity, 'has-downloaded', false );
